'use client';

interface StepperProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  labels: { decrease: string; increase: string };
  /** Classes additionnelles sur le conteneur (variantes de taille / d'espacement). */
  className?: string;
}

/**
 * Incrémenteur « − valeur + » du tunnel : primitive partagée par le sélecteur de quantité et
 * celui de taille de groupe. Un `<input type="number">` natif rend des flèches minuscules,
 * différentes d'un navigateur à l'autre et hors du langage visuel du tunnel — ici deux cibles
 * tactiles de 32 px, bornées, avec des `aria-label` explicites.
 */
export function Stepper({ value, onChange, min = 1, max = 10, labels, className }: StepperProps) {
  return (
    <div className={['bt-stepper', className].filter(Boolean).join(' ')}>
      <button
        type="button"
        className="bt-stepper__btn"
        onClick={(): void => onChange(Math.max(min, value - 1))}
        disabled={value <= min}
        aria-label={labels.decrease}
      >
        −
      </button>
      <span className="bt-stepper__value">{value}</span>
      <button
        type="button"
        className="bt-stepper__btn"
        onClick={(): void => onChange(Math.min(max, value + 1))}
        disabled={value >= max}
        aria-label={labels.increase}
      >
        +
      </button>
    </div>
  );
}
